import { Button } from "@scaffquote/ui";
import { RefreshCw } from "lucide-react";
import { useAppUpdate } from "../lib/pwa.ts";

/**
 * "Update ready" bar. Never reloads by itself mid-session; Restart is only
 * offered when no field work is waiting to sync.
 */
export function UpdatePrompt() {
  const update = useAppUpdate();
  if (!update.ready) return null;
  return (
    <output className="flex flex-wrap items-center gap-x-3 gap-y-1 border-line border-b bg-info-soft px-4 py-2 text-info text-sm">
      <RefreshCw aria-hidden className="size-4 shrink-0" />
      <span className="flex-1">
        An update is ready. It applies the next time you open scaffquote.
        {update.canRestart ? null : " Sync your field work before restarting."}
      </span>
      {update.canRestart ? (
        <Button size="sm" variant="secondary" onClick={update.restart}>
          Restart now
        </Button>
      ) : null}
    </output>
  );
}
